import {
  Compass,
  Stethoscope,
  Activity,
  Target,
  ShieldCheck,
  Briefcase,
  Lightbulb,
  Building2,
  Globe2,
  Mic,
  Scale,
  Lock,
  Cpu,
  Eye,
  Zap,
  HeartPulse,
  Award,
  Crown,
  BookOpen,
  Heart,
  type LucideIcon,
} from "lucide-react";

export type AccentColor =
  | "red"
  | "coral"
  | "purple"
  | "cyan"
  | "denim"
  | "emerald"
  | "lime"
  | "amber-gold";

export const ACCENT_CYCLE: AccentColor[] = [
  "red",
  "coral",
  "purple",
  "cyan",
  "denim",
  "emerald",
  "lime",
  "amber-gold",
];

export interface ParsedSection {
  heading: string;
  level: 2 | 3;
  body: string;
}

export interface Article {
  categorySlug: string;
  categoryLabel: string;
  sourceDir: string;
  slug: string;
  title: string;
  excerpt: string;
  sections: ParsedSection[];
  readingTime: number;
  accent: AccentColor;
  iconName: string;
  meta: { date: string; indexInCategory: number; indexOverall: number };
}

export interface CategoryDef {
  slug: string;
  label: string;
  overline: string;
  description: string;
  longDescription: string;
  iconName: string;
  accent: AccentColor;
  sourceDirs: string[];
  keywords: string[];
}

const ICON_LUCIDE_MAP: Record<string, LucideIcon> = {
  Compass,
  Stethoscope,
  Activity,
  Target,
  ShieldCheck,
  Briefcase,
  Lightbulb,
  Building2,
  Globe2,
  Mic,
  Scale,
  Lock,
  Cpu,
  Eye,
  Zap,
  HeartPulse,
  Award,
  Crown,
  BookOpen,
  Heart,
};

export function resolveIcon(name: string): LucideIcon {
  return ICON_LUCIDE_MAP[name] || BookOpen;
}
